export function reachGoalOplatit(source) {
    console.log("[YM] reachGoal oplatit", source || "");

    if (typeof ym === "function") {
        ym(76606296, "reachGoal", "oplatit");
        console.log("[YM] reachGoal oplatit sent, counter 76606296");
    } else {
        console.warn("[YM] ym is not defined, reachGoal oplatit skipped");
    }
}
